const SDK_PAUSED = 'SDK_PAUSED';

function PauseResme (game) {
  // console.log('init pause and resume');
  game.globalPauseActive = false;
  // game.sdk.setPauseFunction(() => {
  //   if (!game.globalPauseActive) {
  //     game.globalPauseActive = true;
  //     if (game.scene.isActive('SoundManager')) {
  //       let SoundManager = game.scene.getScene('SoundManager');
  //       SoundManager.sdkStop();
  //     }
  //     // console.log('TODO: Sdk Pause');
  //     _.each(game.scene.scenes, (s) => {
  //       let key = s.scene.key;
  //       if (game.scene.isActive(key) && key !== 'SoundManager') {
  //         s.data.set(SDK_PAUSED, true);
  //         game.scene.pause(key);
  //         // console.log('SDK Pause', key);
  //       }
  //     });
  //   }
  // });
  // game.sdk.setPlayFunction(() => {
  //   if (game.globalPauseActive) {
  //     game.globalPauseActive = false;
  //     _.each(game.scene.scenes, (s) => {
  //       let key = s.scene.key;
  //       if (s.data.get(SDK_PAUSED)) {
  //         s.data.set(SDK_PAUSED, false);
  //         if (s.onSdkResume) {
  //           s.onSdkResume();
  //         } else {
  //           // console.log('SDK Resume', key);
  //           game.scene.resume(key);
  //         }
  //       }
  //     });
  //   }
  // });
}

export default PauseResme;
